module.exports = __webpack_public_path__ + "static/media/natural_care.c4ea42b6.svg";